import React, { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import parseHtml from "html-react-parser";
import { Header2 } from "./Header.jsx";
import { useNavigate } from "react-router-dom";
import Webcam from "react-webcam";
import { API_URL, API_URL_SAVE_ANSWER, PENGAWAS_API_URL, SECRET_SESSION } from "../constants.js";
import CountdownTimer from "./shares/CountdownTimer.js";
import { FaArrowRight, FaArrowLeft, FaCheck } from "react-icons/fa";
import ConfirmationModal from "./shares/ConfirmationModal.js";
import NoCopyText from "./shares/NoCopyText.js";
import { decrypt, decrypt_res, encrypt_res } from "./shares/GlobalFunction.jsx";
import AlertModal from "./shares/AlertModal.js";
import PauseModal from "./shares/PauseModal.js";
import Toggle from "./shares/ToggleSwitch.js";
import moment from "moment-timezone";
import Loader from "./shares/Loader.jsx";
import AlertProgres from "./shares/AlertProgres.js";
import axiosInstance from "./shares/axiosConfig.js";
import AudioQuestion from './shares/AudioQuestion';
import MessageModal from "./shares/MessageModal.js";
import { getMessaging, onMessage } from "firebase/messaging";
import Swal from "sweetalert2";
import { 
  ACCESS_STATUS_CONFIG,
  checkAccessStatus,
  checkPesanPengawas,
  registerFCMToken,
  clearAccessStatusCheckTimers,
  clearNotificationCheckTimers
} from '../utils/testNotificationUtils';

function ProsesTest2() {
  const [isLoading, setIsLoading] = React.useState(true);
  const [effectsCompleted, setEffectsCompleted] = React.useState(0);
  const [isMessageModalOpen, setModalMessageOpen] = useState(false);
  const [pesanPengawas, setPesanPengawas] = useState("");
  const [timeStamp, setTimeStamp] = useState("");
  const navigate = useNavigate();
  const timerRef = useRef();
  const [starTimer, setStarTimer] = useState("start");

  // Add a new ref to store the access status check interval
  const accessStatusCheckIntervalRef = useRef([]);

  // add a new ref to store the notification check interval
  const notificationCheckIntervalRef = useRef([]);

  // Add new state to track access status
  const [accessStatus, setAccessStatus] = useState(null);
  const [isBtnNavigasiEnabled, setIsBtnNavigasiEnabled] = React.useState(false);

  // Add state for FCM setup
  const [fcmInitialized, setFcmInitialized] = useState(false);

  // Initialize FCM if that's the chosen method
  React.useEffect(() => {
    if (ACCESS_STATUS_CONFIG.method === 'fcm' && !fcmInitialized) {
      registerFCMToken(
        userData,
        setFcmInitialized,
        setStarTimer,
        timerRef,
        setStopModalOpen
      );
    }
  }, []);

  React.useEffect(() => {
    if (effectsCompleted >= 3) {
      setIsLoading(false);
    }
  }, [effectsCompleted]);

  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
  } else {
    navigate("/login");
  }

  const [pesan, setPesan] = useState("Tes Anda dihentikan sementara. Silahkan hubungi pengawas.");

  // Set up access status checking
  React.useEffect(() => {
    // Only run interval-based checks if that's the configured method
    if (ACCESS_STATUS_CONFIG.method === 'interval') {
      checkAccessStatus(
        userData,
        id_ujian,
        accessStatusCheckIntervalRef,
        setAccessStatus,
        setCatatan,
        setStarTimer,
        setStopModalOpen,
        timerRef,
        navigate
      );
      checkPesanPengawas(
        userData,
        notificationCheckIntervalRef,
        setModalMessageOpen,
        setPesanPengawas,
        setTimeStamp
      );
    }
    
    // Cleanup on component unmount
    return () => {
      clearAccessStatusCheckTimers(accessStatusCheckIntervalRef);
      clearNotificationCheckTimers(notificationCheckIntervalRef);
    };
  }, [userData.id_projek, userData.id_siswa, userData.pengawas, id_ujian, navigate]);

  let id_test = localStorage.getItem("mulai_ujian");
  if (id_test) {
    id_test = JSON.parse(decrypt(id_test));
  } else {
    navigate("/login");
  }

  let id_ujian = localStorage.getItem("id_ujian");

  const [post, setPost] = React.useState(null);

  React.useEffect(() => {
    axios.post(API_URL + "/login/info").then((response) => {
      response.data.res = JSON.parse(
        decrypt_res(response.data.res, SECRET_SESSION)
      );
      setPost(response.data.res);
    });
    setEffectsCompleted((prev) => prev + 1);
  }, []);


  const [Subtest, setSubtest] = React.useState(null);
    const [DaftarSoal, setDaftarSoal] = React.useState(null);


  let initialStatus = [].fill("");
  const [statusJawaban, setStatusJawaban] = useState(initialStatus);
  const [idSoal, setIdSoal] = useState(initialStatus);
  const [waktuMengerjakan, setWaktuMengerjakan] = useState(initialStatus);
  const [statusSave, setStatusSave] = useState(initialStatus);

  let tPertanyaan = localStorage.getItem("tampilPertanyaan") || true;
  let tJawaban = localStorage.getItem("tampilJawaban") || false;
  let sAktif = parseInt(localStorage.getItem("soalAktif")) || 0;
  let cBack = localStorage.getItem("canBack") || false;

  const [tampilPertanyaan, setTampilPertanyaan] = useState(tPertanyaan);
  const [tampilJawaban, setTampilJawaban] = useState(tJawaban);
  const [soalAktif, setSoalAktif] = useState(sAktif);
  const [canBack, setCanBack] = useState(cBack);
  const [autoNext] = useState(false);
  // setCanBack(cBack);


  React.useEffect(() => {
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      nopes: userData.nopes,
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/get_soal_aktif", {data: payload}).then((response) => {
      
      if (response.data.status === 200) {
        setSoalAktif(parseInt(response.data.data.soal_aktif));
        localStorage.setItem("soalAktif", parseInt(response.data.data.soal_aktif));

        if (response.data.data.value !== '') setShowNext(true);
        setActiveTabIndex(parseInt(response.data.data.soal_aktif));
        setNoSoal(parseInt(response.data.data.soal_aktif) + 1);

      } else {
        setSoalAktif(sAktif);
        setActiveTabIndex(sAktif);
        setNoSoal(sAktif + 1);
      }

      
    });
  }, []);

  React.useEffect(() => {
    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      username: userData.nopes,
      kode_akses: userData.kode_akses,
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );
    axiosInstance
      .post(API_URL + "/peserta/subtest", {
        data: encryptedPayload,
      })
      .then((response) => {
        // console.log(response);
        // alert(JSON.stringify(response.data.data[0]));
        let decResponse = JSON.parse(
          decrypt_res(response.data.data, SECRET_SESSION)
        );

        let detailTes = decResponse[0];

        // Check for access denied response
        if (detailTes.error_message) {
          alert(detailTes.error_message);
          navigate("/peserta/logout");
          return;
        }
        if (detailTes.tipe_tes === 1) {
          navigate("/peserta/start_test");
        }

        if (parseInt(response.data.data[0].jenis_tes) === 20) {
          navigate("/peserta/start_test_kraeplin");
        }

        if (detailTes.akses_ujian) {
          if (detailTes.akses_ujian === "pause") {
            // setStarTimer("pause");
            // setPauseModalOpen(true);
          } else if (detailTes.akses_ujian === "logout") {
            setStarTimer("pause");
            setStopModalOpen(true);
            // navigate("/peserta/logout");
          }
        }

        setSubtest(detailTes);

        const payload = {
          id_projek: userData.id_projek,
          id_siswa: userData.id_siswa,
          id_projek_ujian: id_test,
          id_naskah: detailTes.id_naskah,
          kode_paket_soal: detailTes.id_paket_soal,
          id_ujian: id_ujian,
          timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
        };

        const encryptedPayload = encrypt_res(
          JSON.stringify(payload),
          SECRET_SESSION
        );

        axiosInstance
          .post(API_URL + "/peserta/daftarsoal", {
            data: encryptedPayload,
          })
          .then((response) => {
            response.data.data = JSON.parse(
              decrypt_res(response.data.data, SECRET_SESSION)
            );

            response.data.answer = JSON.parse(
              decrypt_res(response.data.answer, SECRET_SESSION)
            );

            setDaftarSoal(response.data.data);
            let newStatusJawaban = [];
            let newIdSoal = [];
            let newStatusSave = [];
            let newWaktuMengerjakan = [];
            let newJenisSoal = [];

            let localStatusJawaban = localStorage.getItem("statusJawaban");
            let localStatusSave = localStorage.getItem("statusSave");
            let localIdSoal = localStorage.getItem("idSoal");
            let localWaktuMengerjakan =
              localStorage.getItem("waktuMengerjakan");

            if (localWaktuMengerjakan) {
              newWaktuMengerjakan = JSON.parse(
                localStorage.getItem("waktuMengerjakan")
              );
            } else {
              if (response.data.redis===1) {
                newWaktuMengerjakan = response.data.answer.waktuMengerjakan.split(",");

                localStorage.setItem(
                  "waktuMengerjakan",
                  JSON.stringify(newWaktuMengerjakan)
                );
              } else {
                response.data.answer.map((item) => {
                  //moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
                  newWaktuMengerjakan[item.no_soal - 1] = moment(
                    item.waktu_mengerjakan
                  ).format("YYYY-MM-DD HH:mm:ss");
                  return item;
                });

                localStorage.setItem(
                  "waktuMengerjakan",
                  JSON.stringify(newWaktuMengerjakan)
                );
              }
            }

            // if (localIdSoal) {
            //   newIdSoal = JSON.parse(localStorage.getItem("idSoal"));
            // } else {
            //   response.data.answer.map((item) => {
            //     newIdSoal[item.no_soal - 1] = item.id_soal;
            //     return item;
            //   });

            //   localStorage.setItem("idSoal", JSON.stringify(newIdSoal));
            // }

            response.data.data.listSoal.map((item) => {
              newIdSoal[item.no_soal - 1] = parseInt(item.id_soal);
              return item;
            });
            localStorage.setItem("idSoal", JSON.stringify(newIdSoal));

            response.data.data.listSoal.map((item) => {
              newJenisSoal[item.no_soal - 1] = parseInt(item.jenis_soal);
              return item;
            });
            localStorage.setItem("jenisSoal", JSON.stringify(newJenisSoal));

            if (localStatusSave) {
              newStatusSave = JSON.parse(localStorage.getItem("statusSave"));
            }

            if (localStatusJawaban) {
              newStatusJawaban = JSON.parse(
                localStorage.getItem("statusJawaban")
              );
            } else {
              if (response.data.redis===1) {
                newStatusJawaban = response.data.answer.statusJawaban.split(",");

                localStorage.setItem(
                  "statusJawaban",
                  JSON.stringify(newStatusJawaban)
                );
              } else {
                response.data.answer.map((item) => {
                  if (parseInt(item.jenis_soal) === 1)
                    newStatusJawaban[item.no_soal - 1] = item.jawaban_pilihan;
                  else newStatusJawaban[item.no_soal - 1] = item.jawaban_essai;

                  // newIdSoal[item.no_soal - 1] = item.id_soal;
                  // newWaktuMengerjakan[item.no_soal - 1] = item.waktu_mengerjakan;

                  return item;
                });

                localStorage.setItem(
                  "statusJawaban",
                  JSON.stringify(newStatusJawaban)
                );
              }
            }

            if (newIdSoal) setIdSoal(newIdSoal);
            if (newWaktuMengerjakan) setWaktuMengerjakan(newWaktuMengerjakan);
            if (newStatusSave) setStatusSave(newStatusSave);

            if (newStatusJawaban) {
              setStatusJawaban(newStatusJawaban);
              const initialSelectedValues = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (newStatusJawaban[i] !== "") {
                  initialSelectedValues["jawaban" + i] = newStatusJawaban[i];
                }
              }
              setSelectedValues(initialSelectedValues);

              const initialSelectedCheckBoxValues = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (
                  typeof newStatusJawaban[i] === "string" &&
                  newStatusJawaban[i] !== ""
                ) {
                  initialSelectedCheckBoxValues["jawaban" + i] = new Set(
                    newStatusJawaban[i].split(";")
                  );
                }
              }
              setSelectedCheckBoxValues(initialSelectedCheckBoxValues);

              const initialSelected3Values = {};
              for (let i = 0; i < newStatusJawaban.length; i++) {
                if (
                  typeof newStatusJawaban[i] === "string" &&
                  newStatusJawaban[i] !== ""
                ) {
                  let tmpJawaban = newStatusJawaban[i].split(";");
                  for (let j = 0; j < tmpJawaban.length; j++) {
                    let tmpOpsi = tmpJawaban[j].split("|");
                    initialSelected3Values[tmpOpsi[0]] = parseInt(tmpOpsi[1]);
                  }
                }
              }
              setSelected3Values(initialSelected3Values);
            }
            setEffectsCompleted((prev) => prev + 1);
          });
        setEffectsCompleted((prev) => prev + 1);
      });
  }, [id_test, id_ujian, navigate, userData.id_projek, userData.id_siswa]);

  const webcamRef = useRef(null);
  // const [capturedImage, setCapturedImage] = useState(null);

  // const capture = () => {
  //   //get photo best resolution webcam
  //   if (webcamRef.current) {
  //     const imageSrc = webcamRef.current.getScreenshot({
  //       width: 640,
  //       height: 480,
  //     });
  //     // setCapturedImage(imageSrc);
  //     //axios kirim gambar ke server
  //     // alert(imageSrc);

  //     axiosInstance.post(API_URL + "/peserta/save_image", {
  //       id_projek: userData.id_projek,
  //       id_siswa: userData.id_siswa,
  //       id_ujian: id_ujian,
  //       nopes: userData.nopes,
  //       image: imageSrc,
  //     });
  //   } else {
  //     console.error("Webcam reference is null");
  //   }
  // };

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [noSoal, setNoSoal] = useState(1);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
    setNoSoal(index + 1);
    setCountdown(5);
    setShowOption(false);
    setTampilJawaban(false);
    setTampilPertanyaan(true);
    setShowNext(false);
    localStorage.setItem("tampilPertanyaan", true);
    localStorage.setItem("tampilJawaban", false);
    localStorage.setItem("soalAktif", index);

    //set soal aktif ke redis
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      nopes: userData.nopes,
      soal_aktif : index
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_soal_aktif", {data: payload});
  };

  const handleNextTab = () => {
    if (activeTabIndex < DaftarSoal.listSoal.length - 1) {
      let nextIndex = activeTabIndex + 1;

      if (canBack) {
        let emptyIndex = statusJawaban.findIndex(
          (item) => item === "" || item === null || item === undefined
        );
        if (emptyIndex !== -1) {
          handleTabChange(emptyIndex);
        } else {
          let index = statusJawaban.length - 1;
          setActiveTabIndex(index);
          setNoSoal(index + 1);

          if (statusJawaban[index] !== "") {
            setTampilJawaban(true);
            setShowNext(true);
          }
          //handleTabChange(statusJawaban.length - 1);
        }
      } else {
        handleTabChange(nextIndex);
      }
    }
  };

  const handlePreviousTab = () => {
    let nextIndex = activeTabIndex - 1;
    setActiveTabIndex(nextIndex);
    setNoSoal(nextIndex + 1);
  };

  const setTab = (index) => {
    if (canClikTab) {
      setActiveTabIndex(index);
      setNoSoal(index + 1);
    }
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const [fontSize, setFontSize] = useState(16); // Initial font size in pixels

  const increaseFontSize = () => {
    setFontSize((prevSize) => prevSize + 2); // Increase font size by 2px
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 10)); // Decrease font size by 2px but not below 10px
  };

  const handleFinishTest = () => {
    const hasEmpty = statusJawaban.some(
      (item) => item === "" || item === null || item === undefined
    );

    let localJawban = localStorage.getItem("statusJawaban");

    let countEmpty = 0;
    if (localJawban) {
      localJawban = localJawban.split(",");
      countEmpty = localJawban.filter(
        (item) => item === "" || item === "null" || item === undefined
      ).length;
    }

    if (
      countEmpty > 0 ||
      hasEmpty ||
      statusJawaban.length === 0 ||
      statusJawaban.length < DaftarSoal.listSoal.length
    ) {
      setAlertModalOpen(true);
    } else {
      handleOpenModal();
    }
    // let isAllAnswered = statusJawaban.every((item) => item !== "");
    // if (isAllAnswered) {
    //   handleOpenModal();
    // } else {
    //   setAlertModalOpen(true);
    // }
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [isPauseModalOpen, setPauseModalOpen] = useState(false);
  const [isStopModalOpen, setStopModalOpen] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);
  const [isAlertTimeOutOpen, setAlertTimeOutOpen] = useState(false);
  const [isAlertProgresOpen, setAlertProgresOpen] = useState(false);
  const [alertVisible, setAlertVisible] = useState(false);
  
    const handleOpenModal = () => {
      setModalOpen(true);
    };

  const handleOpenModalTimeout = () => {
    if (!isAlertProgresOpen) {
      setAlertTimeOutOpen(true);
      clearAllTimers();
    }
  };

  const handleConfirm = () => {
    clearAllTimers();
    setModalOpen(false);
    setAlertTimeOutOpen(false);
    setAlertProgresOpen(true);
    //set status ujian selesai
    let localStatusSave = localStorage.getItem("statusSave") || "[]";
    if (localStatusSave) {
      localStatusSave = JSON.parse(localStatusSave);
    }

    let localStatusJawaban = localStorage.getItem("statusJawaban") || "[]";
    if (localStatusJawaban) {
      localStatusJawaban = JSON.parse(localStatusJawaban);
    }

    let localWaktuMengerjakan =
      localStorage.getItem("waktuMengerjakan") || "[]";
    if (localWaktuMengerjakan) {
      localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
    }

    let localIdSoal = localStorage.getItem("idSoal") || "[]";
    if (localIdSoal) {
      localIdSoal = JSON.parse(localIdSoal);
    }

    let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
    if (localJenisSoal) {
      localJenisSoal = JSON.parse(localJenisSoal);
    }

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join(","),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      statusSave: localStatusSave.join(","),
      jenisSoal: localJenisSoal.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance
      .post(API_URL_SAVE_ANSWER + "/peserta/autosave_jawaban", {
        data: encryptedPayload,
      })
      .then((res) => {
        if (res.status === 200) {
          const payload = {
            id_projek: userData.id_projek,
            id_siswa: userData.id_siswa,
            id_projek_ujian: id_test,
            id_ujian: id_ujian,
            id_naskah: Subtest.id_naskah,
            jawaban: "",
            nopes: userData.nopes,
            kode_akses: userData.kode_akses,
          };

          const encryptedPayload = encrypt_res(
            JSON.stringify(payload),
            SECRET_SESSION
          );

          axiosInstance
            .post(API_URL + "/peserta/selesaites", {
              data: encryptedPayload,
            })
            .then((response) => {
              // alert(JSON.stringify(response.data.data));
              if (parseInt(response.data.data) === 1) {
                localStorage.removeItem("statusJawaban");
                localStorage.removeItem("mulai_ujian");
                localStorage.removeItem("id_ujian");
                navigate("/peserta/confirmtoken");
              } else {
                localStorage.removeItem("statusJawaban");
                localStorage.removeItem("mulai_ujian");
                localStorage.removeItem("id_ujian");
                navigate("/peserta/finish_test");
              }
              localStorage.removeItem("statusJawaban");
              localStorage.removeItem("tampilPertanyaan");
              localStorage.removeItem("tampilJawaban");
              localStorage.removeItem("soalAktif");
              localStorage.removeItem("canBack");
              localStorage.removeItem("waktuMengerjakan");
              localStorage.removeItem("idSoal");
              localStorage.removeItem("countdown");
              localStorage.removeItem("statusSave");
              localStorage.removeItem("jenisSoal");
            });
        } else {
          setAlertProgresOpen(false);
          setAlertVisible(true);
        }
      });
  };

  const handleToEmpty = () => {
    //get index of empty value
    let emptyIndex = statusJawaban.findIndex(
      (item) => item === "" || item === null || item === undefined
    );
    setCanBack(true);
    setAlertModalOpen(false);
    handleTabChange(emptyIndex);
    localStorage.setItem("canBack", true);
  };

  const handleCancel = () => {
    setModalOpen(false);
    setAlertModalOpen(false);
  };

  const saveAnswerRedis = () => {

    let localStatusJawaban = localStorage.getItem("statusJawaban") || "[]";
    if (localStatusJawaban) {
      localStatusJawaban = JSON.parse(localStatusJawaban);
    }

    let localIdSoal = localStorage.getItem("idSoal") || "[]";
    if (localIdSoal) {
      localIdSoal = JSON.parse(localIdSoal);
    }

    let localWaktuMengerjakan = localStorage.getItem("waktuMengerjakan") || "[]";
    if (localWaktuMengerjakan) {
      localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
    }
    let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
    if (localJenisSoal) {
      localJenisSoal = JSON.parse(localJenisSoal);
    }

    const payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: parseInt(id_ujian),
      jumlah_soal: DaftarSoal.listSoal.length,
      soal: localIdSoal.join(","),
      statusJawaban: localStatusJawaban.join(","),
      jenisSoal: localJenisSoal.join(","),
      waktuMengerjakan: localWaktuMengerjakan.join(","),
      timePost: moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
    };

    const encryptedPayload = encrypt_res(
      JSON.stringify(payload),
      SECRET_SESSION
    );

    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_jawaban_redis", {data: encryptedPayload});
  };

  const [selectedValues, setSelectedValues] = useState({});

  const handleRadioChange = (group) => (event) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: event.target.value,
    }));

    setShowNext(true);

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.value;
      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
      return newStatus;
    });

    const waktu_mengerjakan = moment()
      .tz("Asia/Bangkok")
      .format("YYYY-MM-DD HH:mm:ss");

    setWaktuMengerjakan((prevWaktuMengerjakan) => {
      let newStatus = [...prevWaktuMengerjakan];
      newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
      localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
      return newStatus;
    });

    setIdSoal((prevIdSoal) => {
      let newStatus = [...prevIdSoal];
      newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
      localStorage.setItem("idSoal", JSON.stringify(newStatus));
      return newStatus;
    });

    setStatusSave((prevStatusSave) => {
      let newStatus = [...prevStatusSave];
      newStatus[parseInt(group.replace("jawaban", ""))] = 0;
      localStorage.setItem("statusSave", JSON.stringify(newStatus));
      return newStatus;
    });
    // alert(event.target.title);

    //kirim jawaban dengan axios async
    // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
    //   id_projek: userData.id_projek,
    //   id_siswa: userData.id_siswa,
    //   id_ujian: id_ujian,
    //   id_soal: event.target.title,
    //   jenis_soal: 1,
    //   jawaban_pilihan: event.target.value,
    //   jawaban_essai: "",
    //   waktu_mengerjakan: waktu_mengerjakan,
    // });

    setTimeout(() => {
      saveAnswerRedis();
    }, 1000);

    if (isAuto) handleNextTab();
  };

  const [selectedCheckBoxValues, setSelectedCheckBoxValues] = useState({});
  const handleCheckBoxChange = (group, event) => {
    const value = event.target.value;
    setSelectedCheckBoxValues((prevValues) => {
      const newValues = { ...prevValues };
      if (!newValues[group]) {
        newValues[group] = new Set();
      }
      if (newValues[group].has(value + "|1")) {
        newValues[group].delete(value + "|1");
      } else {
        newValues[group].delete(value + "|0");
        newValues[group].add(value + "|1");
      }

      const sortedValues = Array.from(newValues[group]).sort();
      newValues[group] = new Set(sortedValues);

      const waktu_mengerjakan = moment()
        .tz("Asia/Bangkok")
        .format("YYYY-MM-DD HH:mm:ss");

      setWaktuMengerjakan((prevWaktuMengerjakan) => {
        let newStatus = [...prevWaktuMengerjakan];
        newStatus[parseInt(group.replace("jawaban", ""))] = waktu_mengerjakan;
        localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus));
        return newStatus;
      });

      setIdSoal((prevIdSoal) => {
        let newStatus = [...prevIdSoal];
        newStatus[parseInt(group.replace("jawaban", ""))] = event.target.title;
        localStorage.setItem("idSoal", JSON.stringify(newStatus));
        return newStatus;
      });

      setStatusSave((prevStatusSave) => {
        let newStatus = [...prevStatusSave];
        newStatus[parseInt(group.replace("jawaban", ""))] = 0;
        localStorage.setItem("statusSave", JSON.stringify(newStatus));
        return newStatus;
      });

      //kirim jawaban dengan axios async
      // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
      //   id_projek: userData.id_projek,
      //   id_siswa: userData.id_siswa,
      //   id_ujian: id_ujian,
      //   id_soal: event.target.title,
      //   jenis_soal: 2,
      //   jawaban_pilihan: "",
      //   jawaban_essai: Array.from(newValues[group]).join(";"),
      //   waktu_mengerjakan: waktu_mengerjakan,
      // });

      setShowNext(true);

      setStatusJawaban((prevStatusJawaban) => {
        let newStatus = [...prevStatusJawaban];
        newStatus[parseInt(group.replace("jawaban", ""))] = Array.from(
          newValues[group]
        ).join(";");
        localStorage.setItem("statusJawaban", JSON.stringify(newStatus));
        return newStatus;
      });

      setTimeout(() => {
        saveAnswerRedis();
      }, 1000);

      return newValues;
    });
  };

  const [selected3Values, setSelected3Values] = useState({});
  const handleRadio3Change = (group, count, index) => (event) => {
    setSelected3Values((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: parseInt(event.target.value),
    }));

    setStatusJawaban((prevStatusJawaban) => {
      let newStatus = [...prevStatusJawaban];
      const selectedValues = [];
      for (let i = 0; i < count; i++) {
        const radioButtons = document.querySelectorAll(
          'input[name="jawaban-' + index + "-" + i + '"]'
        );

        // alert('input[name="jawaban' + index + "-" + i + '"]');
        // Filter selected radio buttons and extract their values
        selectedValues[i] = Array.from(radioButtons)
          .filter((radio) => radio.checked)
          .reduce((acc, radio) => {
            acc = radio.alt + "|" + radio.value;
            // acc[radio.name] = radio.value; // or acc[radio.id] = radio.value;
            return acc;
          }, "");
      }
      // let newData = Array.from(selectedValues).join(",");
      // alert(newData);
      // alert(selectedValues.join("|"));
      const hasEmpty = selectedValues.some(
        (item) => item === "" || item === null || item === undefined
      );

      if (!hasEmpty) {
        newStatus[index] = selectedValues.join(";");

        const waktu_mengerjakan = moment()
          .tz("Asia/Bangkok")
          .format("YYYY-MM-DD HH:mm:ss");

        setWaktuMengerjakan((prevWaktuMengerjakan) => {
          let newStatus1 = [...prevWaktuMengerjakan];
          newStatus1[index] = waktu_mengerjakan;
          localStorage.setItem("waktuMengerjakan", JSON.stringify(newStatus1));
          return newStatus1;
        });

        setIdSoal((prevIdSoal) => {
          let newStatus1 = [...prevIdSoal];
          newStatus1[index] = event.target.title;
          localStorage.setItem("idSoal", JSON.stringify(newStatus1));
          return newStatus1;
        });

        setStatusSave((prevStatusSave) => {
          let newStatus3 = [...prevStatusSave];
          newStatus3[index] = 0;
          localStorage.setItem("statusSave", JSON.stringify(newStatus3));
          return newStatus3;
        });

        //kirim jawaban dengan axios async
        // axiosInstance.post(API_URL + "/peserta/save_jawaban", {
        //   id_projek: userData.id_projek,
        //   id_siswa: userData.id_siswa,
        //   id_ujian: id_ujian,
        //   id_soal: event.target.title,
        //   jenis_soal: 3,
        //   jawaban_pilihan: "",
        //   jawaban_essai: newStatus[index],
        //   waktu_mengerjakan: waktu_mengerjakan,
        // });

        setShowNext(true);

        if (isAuto) handleNextTab();
        // newStatus[parseInt(group.replace("jawaban", "").split("-")[1])] =
        //   selectedValues.join(";");
      } else {
        newStatus[index] = "";
        // newStatus[parseInt(group.replace("jawaban", "").split("-")[1])] = "";
      }

      localStorage.setItem("statusJawaban", JSON.stringify(newStatus));

      setTimeout(() => {
        saveAnswerRedis();
      }, 1000);

      return newStatus;
    });
  };
  const [isAuto, setIsAuto] = useState(false);

  const handleToggle = (isOn) => {
    setIsAuto(isOn);
    // Perform actions based on the toggle state
  };

  const [countdown, setCountdown] = useState(5);
  const [showQuestion, setShowQuestion] = useState(false);
  useEffect(() => {
    if (tampilJawaban) {
      // setTampilJawaban(false);
      setCountdown(0);
      setShowOption(true);
    } else {
      if (countdown > 0) {
        const timer = setInterval(() => {
          setCountdown((prevCountdown) => prevCountdown - 1);
        }, 1000);

        return () => clearInterval(timer);
      } else {
        setShowQuestion(true);
        if (tampilPertanyaan) {
          setTampilJawaban(false);
          setCountdown2(
            parseInt(DaftarSoal.listSoal[soalAktif].waktu_stimulus)
          );
          // setCountdown2(5);
        }
        // setShowOption(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown]);

  const [countdown2, setCountdown2] = useState(0);
  const [showOption, setShowOption] = useState(false);
  useEffect(() => {
    if (countdown2 > 0) {
      const timer2 = setInterval(() => {
        setCountdown2((prevCountdown) => prevCountdown - 1);
      }, 1000);

      return () => clearInterval(timer2);
    } else {
      setShowQuestion(false);
      localStorage.setItem("tampilPertanyaan", false);
      localStorage.setItem("tampilJawaban", true);
      if (countdown === 0) setShowOption(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdown2]);

  // Function to check if webcam is available
  // const isWebcamAvailable = async () => {
  //   try {
  //     const stream = await navigator.mediaDevices.getUserMedia({ video: true });
  //     stream.getTracks().forEach((track) => track.stop());
  //     return true;
  //   } catch (err) {
  //     return false;
  //   }
  // };

  //kirim gambar ke server setiap 1 menit jika post.camera !== 0
  const intervalRef = useRef([]);

  // useEffect(() => {
  //   const checkAndCapture = async () => {
  //     if (post && post.camera !== 0 && (await isWebcamAvailable())) {
  //       const interval2 = setInterval(() => {
  //         capture();
  //       }, 60000); // 1 minute interval
  //       intervalRef.current.push(interval2);
  //       return () => clearInterval(interval2);
  //     }
  //   };
  //   checkAndCapture();

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [post]);

  const clearAllTimers = () => {
    intervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    intervalRef.current = [];
    // Also clear access status check timers
    clearAccessStatusCheckTimers(accessStatusCheckIntervalRef);
  };

  // Function to clear all access status check timers
  const clearAccessStatusCheckTimers = () => {
    accessStatusCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    accessStatusCheckIntervalRef.current = [];
  };

  // variable to handle stopModal
  const [catatanPengawas, setCatatan] = useState('');

  // function to clear all notification check timers
  const clearNotificationCheckTimers = () => {
    notificationCheckIntervalRef.current.forEach((intervalId) => clearInterval(intervalId));
    notificationCheckIntervalRef.current = [];
  }


  React.useEffect(() => {
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      nopes: userData.nopes,
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/get_play_audio", {data: payload}).then((response) => {
      // if (response.data.status === 200) {
        setPlayCounts(response.data.data);
      // } else {
      //   setPlayCounts({});
      // }
    });

  }, []);

  const [playCounts, setPlayCounts] = useState({}); // state lokal (diambil dari Redis awalnya)

  const handlePlay = async (id) => {
    // Update ke backend

    setIsBtnNavigasiEnabled(true);
    let payload = {
      id_projek: userData.id_projek,
      id_siswa: userData.id_siswa,
      id_ujian: id_ujian,
      id_soal: id,
      nopes: userData.nopes,
    };
    
    axiosInstance.post(API_URL_SAVE_ANSWER + "/peserta/save_play_audio", {data: payload});
  
    // Update lokal juga (optional untuk re-render langsung)
    setPlayCounts(prev => ({
      ...prev,
      [id]: (prev[id] || 0) + 1,
    }));
  };

  // useEffect(() => {
  //   if (statusJawaban.length > 0) {
  //     if (!isAlertTimeOutOpen) {
  //       const autoSave = async () => {
  //         clearAllTimers();
  //         const interval1 = setInterval(() => {
  //           let localStatusSave = localStorage.getItem("statusSave") || "[]";
  //           if (localStatusSave) {
  //             localStatusSave = JSON.parse(localStatusSave);
  //           }

  //           let localStatusJawaban =
  //             localStorage.getItem("statusJawaban") || "[]";
  //           if (localStatusJawaban) {
  //             localStatusJawaban = JSON.parse(localStatusJawaban);
  //           }

  //           let localWaktuMengerjakan =
  //             localStorage.getItem("waktuMengerjakan") || "[]";
  //           if (localWaktuMengerjakan) {
  //             localWaktuMengerjakan = JSON.parse(localWaktuMengerjakan);
  //           }

  //           let localIdSoal = localStorage.getItem("idSoal") || "[]";
  //           if (localIdSoal) {
  //             localIdSoal = JSON.parse(localIdSoal);
  //           }

  //           let localJenisSoal = localStorage.getItem("jenisSoal") || "[]";
  //           if (localJenisSoal) {
  //             localJenisSoal = JSON.parse(localJenisSoal);
  //           }

  //           const payload = {
  //             id_projek: userData.id_projek,
  //             id_siswa: userData.id_siswa,
  //             id_ujian: parseInt(id_ujian),
  //             soal: localIdSoal.join(","),
  //             statusJawaban: localStatusJawaban.join(","),
  //             waktuMengerjakan: localWaktuMengerjakan.join(","),
  //             statusSave: localStatusSave.join(","),
  //             jenisSoal: localJenisSoal.join(","),
  //             timePost: moment()
  //               .tz("Asia/Bangkok")
  //               .format("YYYY-MM-DD HH:mm:ss"),
  //           };

  //           const encryptedPayload = encrypt_res(
  //             JSON.stringify(payload),
  //             SECRET_SESSION
  //           );

  //           axiosInstance
  //             .post(API_URL_SAVE_ANSWER + "/peserta/autosave_jawaban", {
  //               data: encryptedPayload,
  //             })
  //             .then((response) => {
  //               let newStatusSave = [];
  //               response.data.data.map((item) => {
  //                 // let w1 = moment(item.waktu_mengerjakan);
  //                 // let w2 = moment(localWaktuMengerjakan[item.no_soal]);
  //                 // if (w1.diff(w2, "seconds") >= 0) {
  //                 newStatusSave[item.no_soal] = item.statusCode;
  //                 // } else {
  //                 //   newStatusSave[item.no_soal] = localStatusSave[item.no_soal];
  //                 // }
  //                 return item;
  //               });
  //               setStatusSave(newStatusSave);
  //               localStorage.setItem(
  //                 "statusSave",
  //                 JSON.stringify(newStatusSave)
  //               );

  //               //console.log(response);
  //             });
  //         }, 180000); // 3 minute interval
  //         // }, 10000); // 10 detik interval

  //         const unlisten = navigate((location, action) => {
  //           if (action === "PUSH" || action === "POP") {
  //             clearInterval(interval1);
  //           }
  //         });

  //         intervalRef.current.push(interval1);
  //         return () => {
  //           clearInterval(interval1);
  //           unlisten();
  //         };
  //       };
  //       autoSave();
  //     }
  //   }
  // }, [
  //   isAlertTimeOutOpen,
  //   statusJawaban,
  //   idSoal,
  //   waktuMengerjakan,
  //   statusSave,
  //   id_ujian,
  //   userData.id_projek,
  //   userData.id_siswa,
  //   navigate,
  // ]);

  const [showPrevious] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [canClikTab] = useState(false);

  // Add message handler to the FCM onMessage listener
  useEffect(() => {
    if (!userData.pengawas) return;

    const messaging = getMessaging();
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Received foreground message:', payload);

      // Handle supervisor message
      if (payload.data && payload.data.type === 'SUPERVISOR_MESSAGE') {
        setPesanPengawas(payload.data.message);
        const temp_time = new Date();
        temp_time.setTime(temp_time.getTime() + 7 * 60 * 60 * 1000);
        setTimeStamp(temp_time.toISOString());
        setModalMessageOpen(true);
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [userData.pengawas]);

  // Handle FCM messages
  // const handleFCMMessage = useCallback((payload) => {
  //   console.log('Received FCM message:', payload);
    
  //   if (payload.data) {
  //     const { action, type, message } = payload.data;
      
  //     switch (action) {
  //       case 'STOP_TEST':
  //         handleTestAction('STOP_TEST');
  //         break;
  //       case 'RESET_LOGIN':
  //         handleTestAction('RESET_LOGIN');
  //         break;
  //       case 'SUPERVISOR_MESSAGE':
  //         handleTestAction('SUPERVISOR_MESSAGE', payload.data);
  //         break;
  //       default:
  //         console.log('Unknown action:', action);
  //     }
  //   }
  // }, [handleTestAction]);

  // Initialize FCM messaging
  useEffect(() => {
    const initializeFCM = async () => {
      try {
        const messaging = getMessaging();
        const unsubscribe = onMessage(messaging, (payload) => {
          // handleFCMMessage(payload);
        });
        
        return () => unsubscribe();
      } catch (error) {
        console.error('Error initializing FCM:', error);
      }
    };

    initializeFCM();
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="App" translate="no">
      <PauseModal
        isOpen={isPauseModalOpen}
        title={"Perhatian"}
        subtitle={pesan}
      />

      <PauseModal
        isOpen={isStopModalOpen}
        title={"Perhatian"}
        subtitle={pesan}
      />
      <AlertModal
        isOpen={alertVisible}
        onConfirm={() => setAlertVisible(false)}
        title={"Kesalahan Jaringan"}
        btn_text="Ok."
        subtitle={"Jaringan terganggu. Silakan coba lagi nanti."}
      />

<MessageModal
        isOpen={isMessageModalOpen}
        title="Pesan Pengawas"
        arrayMessages={pesanPengawas}
        subtitle={pesanPengawas}
        // currentMessageIndex={currentMessageIndex}
        // setCurrentMessageIndex={setCurrentMessageIndex}
        // maxIndex={maxIndex}
        // setMaxIndex={setMaxIndex}
        onConfirm={(input) => {
          axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read", 
            {
              id_projek: userData.id_projek,
              id_siswa: userData.id_siswa,
              timestamp: timeStamp
            }
          )
          .then((response) => {
            setModalMessageOpen(false);
          })
          .catch((error) => {
            console.log("Network error pesan jadi tak terbaca");
          });
          // axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/send", 
          //   {
          //     id_projek: userData.id_projek,
          //     id_siswa: userData.id_siswa,
          //     nama_siswa: userData.nama_siswa,
          //     text: input
          //   })
          //   .then((response) => {
          //     // console.log(maxIndex);
          //     input = "";
          //     axiosInstance.post(PENGAWAS_API_URL + "/messaging/PesertaMessageHistory/mark-read", 
          //       {
          //         id_projek: userData.id_projek,
          //         id_siswa: userData.id_siswa,
          //         timestamp: timeStamp
          //       }
          //     );
          //   })
          //   .catch((error) => {
          //     console.log("Pesan gagal dikirim");
          //   });
          setModalMessageOpen(false);
        }}
      />

      {alertVisible && (
        <div className="fixed top-0 left-0 right-0 bg-red-500 text-white p-4 text-center">
          <p>Jaringan terganggu. Silakan coba lagi nanti.</p>
        </div>
      )}
      <ConfirmationModal
        isOpen={isModalOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Apakah Anda yakin akan mengakhiri tes dan melanjutkan ke tes berikutnya ?"
        }
      />

      <AlertModal
        isOpen={isAlertModalOpen}
        onConfirm={handleToEmpty}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Silahkan lengkapi jawaban Anda terlebih dahulu sebelum menyelesaikan ujian."
        }
      />

      <AlertProgres
        isOpen={isAlertProgresOpen}
        title={"Sedang diproses ..."}
        subtitle={""}
      />

      <AlertModal
        isOpen={isAlertTimeOutOpen}
        onConfirm={handleConfirm}
        title={"Konfirmasi Selesai Ujian"}
        subtitle={
          "Waktu tes anda sudah habis, silahkan klik tombol untuk menyelesaikan tes."
        }
      />
      
      <NoCopyText>
        <div 
          className="App-header"
          style={{ backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='150' height='50'><text x='0' y='20' font-size='15' fill='gray' fill-opacity='0.3' transform='rotate(-10, 75, 25)'>${userData.nopes}</text></svg>")` }}
          >
          <Header2 app_name={post && post.alamat} />
          <div
            className="md:flex flex-row w-full gap-5 px-5"
            style={{
              marginTop: "90px",
              // "margin-top": "10px",
              marginBottom: "100px",
            }}
          >
            {post && post.camera !== 0 && (
              <div
                className="webcam-container login-container basis-40  mb-1 pt-2  z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-1 "
                style={{
                  // "margin-bottom": "100px",

                  height: "fit-content",
                }}
              >
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat="image/jpeg"
                  screenshotQuality={0.5} // Adjusted quality to reduce file size
                  width={640} // Adjusted width to reduce file size
                  height={480} // Adjusted height to reduce file size
                  className="w-full max-w-md rounded-md mb-2"
                />
              </div>
            )}
            <div
              className={
                post && post.camera !== 0
                  ? "login-container basis-full  Bg-tutwuri  z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-5"
                  : "login-container w-full  Bg-tutwuri  z-10 bg-white border-1 border-grey-800 rounded-xl shadow-xl p-5"
              }
              style={{
                minHeight: "200px",
              }}
            >
              <div className="flex justify-between pt-1 pb-2">
                <div className="text-center mt-2">
                  <button
                    type="button"
                    className="webcam-container bg-white-500 border-2 border-gray-300 p-1 px-2  text-sm  rounded mr-1"
                  >
                    {Subtest && parseHtml(Subtest.nama_projek)}
                  </button>
                  {/* <button
                    type="button"
                    className="bg-blue-500 border-2  text-white border-blue-500 py-1 px-4  text-sm  rounded"
                  >
                    {noSoal && noSoal}
                  </button> */}
                </div>
                {autoNext && (
                  <div>
                    <Toggle onToggle={handleToggle} />
                  </div>
                )}
                <div className="text-sm mt-1 text-center min-w-[200px]">
                  <div>
                    <span className="webcam-container">Ukuran Huruf : </span>
                    <button
                      onClick={decreaseFontSize}
                      className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600 mr-2"
                    >
                      -
                    </button>
                    <button
                      onClick={increaseFontSize}
                      className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 mr-2"
                    >
                      +
                    </button>
                  </div>
                </div>
                <div className="text-right">
                  <button
                    type="button"
                    className="bg-white-500 border-2 border-gray-300 p-1 px-2  text-sm rounded-xl mr-1 mb-1 "
                  >
                    Sisa Waktu :{" "}
                    <b>
                      {Subtest && (
                        <CountdownTimer
                          status={starTimer}
                          ref={timerRef}
                          initialSeconds={Subtest.sisa_waktu}
                          onTime={handleOpenModalTimeout}
                        />
                      )}
                    </b>
                  </button>
                  <button
                    type="button"
                    onClick={toggleVisibility}
                    className="bg-blue-500 border-2 border-blue-500 text-white text-sm py-1 px-4 rounded-xl"
                  >
                    Daftar Soal
                  </button>
                </div>
              </div>
              <div className="border-t-4 mb-1 border-gray-200 rounded"></div>

              <div
                className="contentSoal border-2 border-gray-200 rounded-md p-4 z-1 custom-height-soal"
                style={{ minHeight: "400px" }}
              >
                {/* <div>{DaftarSoal && JSON.stringify(DaftarSoal.listSoal)}</div> */}
                {DaftarSoal ? (
                  <div
                    className="flex flex-row flex-wrap"
                    style={{ fontSize: `${fontSize}px` }}
                  >
                    {DaftarSoal.listSoal.map((soal, index) => (
                      <div
                        key={soal.id_soal}
                        label={index + 1}
                        className={
                          activeTabIndex === index ? "w-full" : "hidden"
                        }
                      >
                        <div>
                          {parseInt(soal.waktu_stimulus) > 0 &&
                          countdown > 0 ? (
                            <div className="text-center">
                              Bersiap Mengingat... <br />
                              <span className="countdown">
                                {countdown}
                              </span>{" "}
                            </div>
                          ) : null}
                          {soal.waktu_stimulus < 1 || showQuestion ? (
                            <div>
                              <div>{soal.soal && parseHtml(soal.soal)}</div>

                              {/* Render other parts of the question here */}
                            </div>
                          ) : null}

                          {countdown2 > 0 && !tampilJawaban ? (
                            <div className="absolute top-[55px] right-10 text-center pt-4 ">
                              <span className="countdown">{countdown2}</span>{" "}
                            </div>
                          ) : null}

                          {soal.multimedia_file && (
                            <AudioQuestion
                              key={soal.id_soal}
                              id={soal.id_soal}
                              playCount={playCounts[soal.id_soal] || 0}
                              numPlay={post && post.jumlah_play_listening}
                              question={soal.multimedia_file}
                              onPlay={handlePlay}
                              onEndPlay={() => setIsBtnNavigasiEnabled(false)}
                            />
                          
                          )}

                          {soal.waktu_stimulus < 1 || showOption ? (
                            <div>
                              {soal.pertanyaan && (
                                <div>
                                  {soal.pertanyaan &&
                                    parseHtml(soal.pertanyaan)}
                                </div>
                              )}
                              {parseInt(soal.jenis_soal) === 1 && (
                                <div className="grid grid-cols-1 gap-1">
                                  {soal.jumlah_opsi >= 1 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="radio"
                                        className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        value="A"
                                        title={soal.id_soal}
                                        checked={
                                          selectedValues["jawaban" + index] ===
                                          "A"
                                        }
                                        onChange={handleRadioChange(
                                          "jawaban" + index
                                        )}
                                      />
                                      <span>
                                        {soal.opsi_a &&
                                          parseHtml(
                                            soal.opsi_a.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 2 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="radio"
                                        className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        alt={index}
                                        value="B"
                                        title={soal.id_soal}
                                        id={"jawaban" + index + "-B"}
                                        checked={
                                          selectedValues["jawaban" + index] ===
                                          "B"
                                        }
                                        onChange={handleRadioChange(
                                          "jawaban" + index
                                        )}
                                      />
                                      <span>
                                        {soal.opsi_b &&
                                          parseHtml(
                                            soal.opsi_b.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 3 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="radio"
                                        className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        alt={index}
                                        value="C"
                                        title={soal.id_soal}
                                        id={"jawaban" + index + "-C"}
                                        checked={
                                          selectedValues["jawaban" + index] ===
                                          "C"
                                        }
                                        onChange={handleRadioChange(
                                          "jawaban" + index
                                        )}
                                      />
                                      <span>
                                        {soal.opsi_c &&
                                          parseHtml(
                                            soal.opsi_c.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 4 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="radio"
                                        className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        alt={index}
                                        value="D"
                                        title={soal.id_soal}
                                        id={"jawaban" + index + "-D"}
                                        checked={
                                          selectedValues["jawaban" + index] ===
                                          "D"
                                        }
                                        onChange={handleRadioChange(
                                          "jawaban" + index
                                        )}
                                      />
                                      <span>
                                        {soal.opsi_d &&
                                          parseHtml(
                                            soal.opsi_d.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 5 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="radio"
                                        className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        alt={index}
                                        value="E"
                                        title={soal.id_soal}
                                        id={"jawaban" + index + "-E"}
                                        checked={
                                          selectedValues["jawaban" + index] ===
                                          "E"
                                        }
                                        onChange={handleRadioChange(
                                          "jawaban" + index
                                        )}
                                      />
                                      <span>
                                        {soal.opsi_e &&
                                          parseHtml(
                                            soal.opsi_e.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 6 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="radio"
                                        className="form-radio h-5 w-5  checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        alt={index}
                                        value="F"
                                        title={soal.id_soal}
                                        id={"jawaban" + index + "-F"}
                                        checked={
                                          selectedValues["jawaban" + index] ===
                                          "F"
                                        }
                                        onChange={handleRadioChange(
                                          "jawaban" + index
                                        )}
                                      />
                                      <span>
                                        {soal.opsi_f &&
                                          parseHtml(
                                            soal.opsi_f.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}

                                  {/* <p>Selected Values:</p>
                            <p>
                              Group {index}: {selectedValues["jawaban" + index]}
                            </p> */}
                                </div>
                              )}

                              {parseInt(soal.jenis_soal) === 2 && (
                                <div className="grid grid-cols-1 gap-1">
                                  {soal.jumlah_opsi >= 1 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        id={"jawaban" + index}
                                        alt={index}
                                        value={"A"}
                                        title={soal.id_soal}
                                        checked={
                                          selectedCheckBoxValues[
                                            "jawaban" + index
                                          ]?.has("A|1") || false
                                        }
                                        onChange={(event) =>
                                          handleCheckBoxChange(
                                            "jawaban" + index,
                                            event
                                          )
                                        }
                                      />
                                      <span>
                                        {soal.opsi_a &&
                                          parseHtml(
                                            soal.opsi_a.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 2 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        id={"jawaban" + index}
                                        alt={index}
                                        value={"B"}
                                        title={soal.id_soal}
                                        checked={
                                          selectedCheckBoxValues[
                                            "jawaban" + index
                                          ]?.has("B|1") || false
                                        }
                                        onChange={(event) =>
                                          handleCheckBoxChange(
                                            "jawaban" + index,
                                            event
                                          )
                                        }
                                      />
                                      <span>
                                        {soal.opsi_b &&
                                          parseHtml(
                                            soal.opsi_b.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 3 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        id={"jawaban" + index}
                                        alt={index}
                                        value={"C"}
                                        title={soal.id_soal}
                                        checked={
                                          selectedCheckBoxValues[
                                            "jawaban" + index
                                          ]?.has("C|1") || false
                                        }
                                        onChange={(event) =>
                                          handleCheckBoxChange(
                                            "jawaban" + index,
                                            event
                                          )
                                        }
                                      />
                                      <span>
                                        {soal.opsi_c &&
                                          parseHtml(
                                            soal.opsi_c.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 4 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        id={"jawaban" + index}
                                        alt={index}
                                        value={"D"}
                                        title={soal.id_soal}
                                        checked={
                                          selectedCheckBoxValues[
                                            "jawaban" + index
                                          ]?.has("D|1") || false
                                        }
                                        onChange={(event) =>
                                          handleCheckBoxChange(
                                            "jawaban" + index,
                                            event
                                          )
                                        }
                                      />
                                      <span>
                                        {soal.opsi_d &&
                                          parseHtml(
                                            soal.opsi_d.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 5 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        id={"jawaban" + index}
                                        alt={index}
                                        value={"E"}
                                        title={soal.id_soal}
                                        checked={
                                          selectedCheckBoxValues[
                                            "jawaban" + index
                                          ]?.has("E|1") || false
                                        }
                                        onChange={(event) =>
                                          handleCheckBoxChange(
                                            "jawaban" + index,
                                            event
                                          )
                                        }
                                      />
                                      <span>
                                        {soal.opsi_e &&
                                          parseHtml(
                                            soal.opsi_e.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {soal.jumlah_opsi >= 6 && (
                                    <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded flex items-center cursor-pointer">
                                      <input
                                        type="checkbox"
                                        className="form-checkbox h-5 w-5 checked:border-indigo-500 mr-2"
                                        name={"jawaban" + index}
                                        id={"jawaban" + index}
                                        alt={index}
                                        value={"F"}
                                        title={soal.id_soal}
                                        checked={
                                          selectedCheckBoxValues[
                                            "jawaban" + index
                                          ]?.has("F|1") || false
                                        }
                                        onChange={(event) =>
                                          handleCheckBoxChange(
                                            "jawaban" + index,
                                            event
                                          )
                                        }
                                      />
                                      <span>
                                        {soal.opsi_f &&
                                          parseHtml(
                                            soal.opsi_f.replace(
                                              /<\?xml[^>]*>|<\/?p>/gm,
                                              ""
                                            )
                                          )}
                                      </span>
                                    </label>
                                  )}
                                  {/* <p>Selected Values:</p>
                            <p>
                              Group {index}:{" "}
                              {selectedCheckBoxValues["jawaban" + index] &&
                                Array.from(
                                  selectedCheckBoxValues["jawaban" + index]
                                ).join(";")}
                            </p> */}
                                </div>
                              )}

                              {parseInt(soal.jenis_soal) === 3 && (
                                <div className="grid grid-cols-1 gap-1">
                                  <table className="min-w-full bg-white border border-gray-300 rounded">
                                    <thead>
                                      <tr className="bg-gray-200 text-gray-700">
                                        <th className="py-2 px-4 border-b w-10">
                                          No.
                                        </th>
                                        <th className="py-2 px-4 border-b text-left">
                                          {soal.listAnswerText?.[0]?.judul ?? "Pernyataan"}
                                        </th>
                                        {soal.listAnswerText[0].listAnswer.map(
                                          (item, index2) => (
                                            <th
                                              className="py-2 px-4 border-b text-center w-40"
                                              key={item.id}
                                            >
                                              {item.description}
                                            </th>
                                          )
                                        )}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {soal.listAnswerText.map(
                                        (item, index2) => (
                                          <tr
                                            key={item.id}
                                            className="hover:bg-gray-100"
                                          >
                                            <td className="py-2 px-4 border text-center">
                                              {item.group_soal + 1}.
                                            </td>
                                            <td className="py-2 px-4 border">
                                              {parseHtml(
                                                item.text.replace(
                                                  /<[^>]*>?/gm,
                                                  ""
                                                )
                                              )}
                                            </td>
                                            {item.listAnswer.map(
                                              (answer, index3) => (
                                                <td
                                                  className="py-2 px-4 border text-center"
                                                  key={answer.id}
                                                >
                                                  <label className="has-[:checked]:bg-indigo-50 has-[:checked]:text-indigo-900 has-[:checked]:ring-indigo-200 p-2 rounded px-[50px]">
                                                    <input
                                                      type="radio"
                                                      // name={`soal-${item.id}`}
                                                      // value={answer.id}
                                                      className="form-radio h-5 w-5 checked:border-indigo-500"
                                                      name={
                                                        "jawaban-" +
                                                        index +
                                                        "-" +
                                                        index2
                                                      }
                                                      alt={item.id_butir}
                                                      title={soal.id_soal}
                                                      value={index3}
                                                      // checked={
                                                      //   selected3Values[
                                                      //     "jawaban-" +
                                                      //       index +
                                                      //       "-" +
                                                      //       index2
                                                      //   ] === index3
                                                      // }
                                                      checked={
                                                        selected3Values[
                                                          item.id_butir
                                                        ] === index3
                                                      }
                                                      onChange={handleRadio3Change(
                                                        item.id_butir,
                                                        soal.listAnswerText
                                                          .length,
                                                        index
                                                      )}
                                                    />
                                                    {/* {selected3Values[
                                            "jawaban-" + index + "-" + index2
                                          ] + index3} */}
                                                  </label>
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                  {/* <p>Selected Values:</p>
                            <p>
                              Group {index}: {statusJawaban[index]}
                            </p> */}
                                </div>
                              )}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>Loading...</div>
                )}
              </div>
              {!isVisible && (
                <div
                  className={
                    showPrevious
                      ? "flex justify-between pt-5 "
                      : "flex justify-center pt-5"
                  }
                >
                  {showPrevious && (
                    <button
                      type="button"
                      id="btn-previous"
                      onClick={handlePreviousTab}
                      disabled={activeTabIndex === 0}
                      className="flex items-center bg-red-500 hover:bg-red-800 text-white py-2 px-4 rounded-xl h-10 mt-1"
                    >
                      <FaArrowLeft />
                      <span className="pl-2">Soal Sebelumnya</span>
                    </button>
                  )}
                  {showNext && (
                    <button
                      type="button"
                      id="btn-next"
                      disabled={isBtnNavigasiEnabled}
                      onClick={
                        DaftarSoal &&
                        activeTabIndex === DaftarSoal.listSoal.length - 1
                          ? handleFinishTest
                          : handleNextTab
                      }
                      // disabled={
                      //   DaftarSoal &&
                      //   activeTabIndex === DaftarSoal.listSoal.length - 1
                      // }
                      className="flex items-center bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-xl h-10 mt-1"
                    >
                      <span className="pr-2">
                        {DaftarSoal &&
                        activeTabIndex === DaftarSoal.listSoal.length - 1
                          ? "Selesai"
                          : "Soal Selanjutnya"}
                      </span>
                      {DaftarSoal &&
                      activeTabIndex === DaftarSoal.listSoal.length - 1 ? (
                        <FaCheck />
                      ) : (
                        <FaArrowRight />
                      )}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
          {isVisible && (
            <div className=" fixed bottom-0 w-full left-0 px-5 py-1 z-30 ">
              <div className="login-container w-full mb-2   flex justify-between w-full  p-4 bg-white rounded-xl shadow-xl ">
                {showPrevious && (
                  <button
                    type="button"
                    id="btn-previous"
                    onClick={handlePreviousTab}
                    disabled={activeTabIndex === 0}
                    className="flex justify-center items-center text-center bg-red-500 hover:bg-blue-800 text-white py-2 px-4 rounded-xl h-10  mt-1 md:min-w-[190px]"
                  >
                    <FaArrowLeft />
                    <span className="pl-2 hidden sm:inline">
                      Soal Sebelumnya
                    </span>
                  </button>
                )}

                {/* <div className="text-sm">Daftar Soal :</div> */}
                {DaftarSoal ? (
                  <div className="text-sm">
                    <div className="flex flex-row justify-center flex-wrap">
                      {(() => {
                        let nomorSoal = 1; // Declare nomorSoal outside the map function
                        return DaftarSoal.listSoal.map((soal, index) => (
                          <div className="relative inline-block" key={soal.id_soal}>
                            <div className="m-0 rounded-lg">
                              <button
                                key={index}
                                type="button"
                                onClick={setTab.bind(this, index)}
                                className={
                                  activeTabIndex === index
                                    ? "bg-blue-500 border-2 border-blue-400 hover:bg-blue-200 py-2 px-2 rounded m-1"
                                    : "bg-white-500 border-2 border-gray-200 hover:bg-gray-400 py-2 px-2 rounded m-1"
                                }
                                style={
                                  soal.caption_nomor === null
                                    ? { width: "40px" }
                                    : { width: "" }
                                }
                              >
                                {soal.caption_nomor === null ? nomorSoal++ : soal.caption_nomor}
                              </button>
                              {statusJawaban[index] && (
                                <span
                                  className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-sm font-medium text-white bg-blue-500 rounded-full"
                                  style={{ transform: "translate(10%, -10%)" }}
                                >
                                  <FaCheck className="w-2" />
                                </span>
                              )}
                            </div>
                          </div>
                        ));
                      })()}
                    </div>
                  </div>
                ) : (
                  <div>Loading...</div>
                )}
                {showNext && (
                  <button
                    type="button"
                    id="btn-previous"
                    disabled={isBtnNavigasiEnabled}
                    onClick={
                      DaftarSoal &&
                      activeTabIndex === DaftarSoal.listSoal.length - 1
                        ? handleFinishTest
                        : handleNextTab
                    }
                    // disabled={
                    //   DaftarSoal &&
                    //   activeTabIndex === DaftarSoal.listSoal.length - 1
                    // }
                    className="flex justify-center items-center text-center bg-blue-500 hover:bg-blue-800 text-white py-2 px-4 rounded-xl h-10  mt-1 md:min-w-[180px]"
                  >
                    <span className="pr-2 hidden sm:inline">
                      {DaftarSoal &&
                      activeTabIndex === DaftarSoal.listSoal.length - 1
                        ? "Selesai"
                        : "Soal Selanjutnya"}
                    </span>
                    {DaftarSoal &&
                    activeTabIndex === DaftarSoal.listSoal.length - 1 ? (
                      <FaCheck />
                    ) : (
                      <FaArrowRight />
                    )}
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </NoCopyText>
    </div>
  );
}

export default ProsesTest2;
